// extracted by mini-css-extract-plugin
module.exports = {"size":"IconArrowUp_size__kKlGa"};